import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

function Stat({ label, value, sub, testid }) {
  return (
    <div className="bg-white border border-brand-line p-6" data-testid={testid}>
      <p className="overline">{label}</p>
      <p className="font-serif text-5xl text-brand-dark mt-2">{value}</p>
      {sub && <p className="font-sans text-xs text-brand-muted mt-1">{sub}</p>}
    </div>
  );
}

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-8 lg:p-12 max-w-6xl">
      <p className="overline">Overview</p>
      <h1 className="editorial-h text-5xl text-brand-dark mt-2">Dashboard</h1>
      <p className="font-sans text-base text-brand-muted mt-2">Conversion-focused view of your funnel today.</p>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <Stat label="Total Leads" value={data?.total_leads ?? "—"} testid="stat-total" />
        <Stat label="Last 7 days" value={data?.last_7_days ?? "—"} testid="stat-week" />
        <Stat label="WhatsApp Opened" value={data?.wa_opened ?? "—"} sub="Customer tapped Send" testid="stat-wa-opened" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-10">
        <div className="bg-white border border-brand-line p-6">
          <p className="overline mb-4">Leads by rep</p>
          {(data?.per_rep || []).length === 0 && <p className="font-sans text-sm text-brand-muted">No leads yet.</p>}
          {(data?.per_rep || []).map((r) => (
            <div key={r.rep_id} className="flex items-center justify-between py-2 border-b border-brand-line last:border-0">
              <span className="font-sans text-sm text-brand-dark">{r.rep_name} <span className="text-brand-muted">· {r.rep_code}</span></span>
              <span className="font-serif text-xl text-brand-primary">{r.count}</span>
            </div>
          ))}
        </div>
        <div className="bg-white border border-brand-line p-6">
          <p className="overline mb-4">Leads by language</p>
          {(data?.per_language || []).length === 0 && <p className="font-sans text-sm text-brand-muted">No leads yet.</p>}
          {(data?.per_language || []).map((r) => (
            <div key={r.language} className="flex items-center justify-between py-2 border-b border-brand-line last:border-0">
              <span className="font-sans text-sm text-brand-dark uppercase tracking-widest">{r.language}</span>
              <span className="font-serif text-xl text-brand-primary">{r.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-10 flex gap-3 flex-wrap">
        <Link to="/admin/leads" className="bg-brand-primary text-brand-bone px-5 py-3 text-sm font-semibold flex items-center gap-2" data-testid="quick-leads">
          View all leads <ArrowUpRight strokeWidth={1.5} className="w-4 h-4" />
        </Link>
        <Link to="/admin/reps" className="border border-brand-line text-brand-dark px-5 py-3 text-sm font-semibold hover:border-brand-primary" data-testid="quick-reps">
          Manage reps
        </Link>
        <Link to="/admin/products" className="border border-brand-line text-brand-dark px-5 py-3 text-sm font-semibold hover:border-brand-primary" data-testid="quick-products">
          Manage products
        </Link>
      </div>
    </div>
  );
}
